<template>
  <div class="indexBg">
    <div class="help-item">
      <div class="title"># 手机仿真体验结束后怎么返回到小程序首页</div>
      <div class="box">
        <div class="step-item">
          <div class="step">
           第一步：体验结束后点击页面中的返回首页按钮 
          </div>
          <el-image
            class="imgSrc"
            :src="require('@/assets/help/img2-1.png')"
            :preview-src-list="[require('@/assets/help/img2-1.png')]"
            fit="contain"
          >
          </el-image>
        </div>
        <div class="step-item">
          <div class="step">
           第二步：点击右上角的关闭按钮，回到智能手机仿真体验专区
          </div>
          <el-image
            class="imgSrc"
            :src="require('@/assets/help/img2-2.png')"
            :preview-src-list="[require('@/assets/help/img2-2.png')]"
            fit="contain"
          >
          </el-image>
        </div>
        <div class="step-item">
          <div class="step">
           第三步：点击左上角的返回按钮，回到小程序首页
          </div>
          <el-image
            class="imgSrc"
            :src="require('@/assets/help/img2-3.png')"
            :preview-src-list="[require('@/assets/help/img2-3.png')]"
            fit="contain"
          >
          </el-image>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "help1Page",
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},

  async created() {},
  mounted() {},

  beforeDestroy() {},

  methods: {},
};
</script>

<style scoped lang="less">
.indexBg {
  width: 100%;
  height: 100%;
  background: #eeeeee;
  font-family: Alibaba PuHuiTi;
}
.help-item {
  padding: 30px;
  .title {
    color: rgba(0, 0, 0, 1);
    font-family: Alibaba PuHuiTi;
    font-size: 45px;
    font-weight: 600;
    letter-spacing: 0px;
    text-align: left;
    margin: 0px 0 45px;
  }
  .box {
    background: #ffffff;
    padding: 30px;
    border-radius: 20px;
  }
  .step-item {
    margin-bottom: 30px;

    .step {
      font-size: 36px;
      margin-bottom: 20px;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
